import { Path } from '@/types'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class StoryWidgetsMixin extends Vue {
  get activeTab() {
    return this.$typedStore.public.display.activeTab
  }

  get activeTabPath() {
    if (this.activeTab) return new Path({ path: this.activeTab.path })
  }

  get hidePieChartOnRootSubroot() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig
      .hidePiechartOnRootSubroot
  }

  get showPieChartSidebar() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig
      .showPiechartSidebar
  }

  get showPieChart() {
    return (
      this.showPieChartSidebar &&
      !(this.hidePieChartOnRootSubroot && this.activeTabPath?.isRootOrSubroot)
    )
  }

  get sidebarBotFontFamily() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.storySettings
      .sidebarBot.fontFamily
  }

  get pieChartFontFamily() {
    return {
      '--font-family': this.sidebarBotFontFamily,
      'font-family': this.sidebarBotFontFamily,
    }
  }

  get showComparisonGraph() {
    const { show, showOnRoot, showOnSubroot } =
      this.$typedStore.activeVisualisation.visualisationStore.app.config.comparisonGraphSettings
    return (
      show &&
      (!this.activeTabPath?.isRoot || showOnRoot !== false) &&
      (!this.activeTabPath?.isSubroot || showOnSubroot !== false)
    )
  }
}
